import { FilmCategory } from '@vista-digital/ocapi-types/v1';
import { isPast } from 'date-fns';
import { getEarliestAvailableAdvanceBookingPeriod } from '../../utils/films/advance-booking-period-utils';
import { getFilmAvailability } from './get-film-availability';
/**
 * Determines whether a film is currently available for advance bookings by the current patron.
 *
 * A film will be available for advance bookings only if:
 * 1. It belongs to the AdvanceBooking category.
 * 2. The current patron has access to an active advance booking period.
 *
 * It is possible that a film belonging to the AdvanceBooking category will not have an active advance booking period
 * that is available to the current patron due to an unmet MemberReward restriction.
 */
export const isFilmAvailableForAdvanceBookings = (filmId, siteId, bookingMode) => {
    const filmAvailability = getFilmAvailability(filmId, siteId);
    if (!filmAvailability)
        throw new Error(`Cannot find film availability with filmId: ${filmId}.`);
    // A film may have a historical booking period, but will be available for 'regular' bookings instead of 'advance' bookings.
    // See isFilmAvailableForBookings.
    if (!filmAvailability.categories.includes(FilmCategory.AdvanceBooking))
        return false;
    const bookingPeriod = getEarliestAvailableAdvanceBookingPeriod(filmAvailability.advanceBookingPeriods, bookingMode);
    return bookingPeriod ? isPast(new Date(bookingPeriod.startsAt)) : false;
};
